import script from "./SyncManager.vue?vue&type=script&setup=true&lang=ts"
export * from "./SyncManager.vue?vue&type=script&setup=true&lang=ts"

import "./SyncManager.vue?vue&type=style&index=0&id=7944532e&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7944532e"]])

export default __exports__